var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLedgerIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55 41.8496V11.6747C55 8.67474 52.55 6.44974 49.575 6.69974H49.425C44.175 7.14974 36.2 9.82474 31.75 12.6247L31.325 12.8997C30.6 13.3497 29.4 13.3497 28.675 12.8997L28.05 12.5247C23.6 9.74974 15.65 7.09974 10.4 6.67474C7.425 6.42474 5 8.67474 5 11.6497V41.8496C5 44.2496 6.95 46.4996 9.35 46.7996L10.075 46.8996C15.5 47.6246 23.875 50.3746 28.675 52.9996L28.775 53.0496C29.45 53.4246 30.525 53.4246 31.175 53.0496C35.975 50.3996 44.375 47.6246 49.825 46.8996L50.65 46.7996C53.05 46.4996 55 44.2496 55 41.8496Z",
    stroke: "white",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 13.7251V51.2251",
    stroke: "white",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.625 25H14",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 32.5H14",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9441 32.6758C43.5327 32.6758 43.1992 33.0091 43.1992 33.4205C43.1992 33.8319 43.5327 34.1655 43.9441 34.1655H49.654C50.0654 34.1655 50.3988 33.8321 50.3988 33.4205C50.3988 33.0092 50.0655 32.6758 49.654 32.6758H43.9441Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36 25.9722C36 26.3836 36.3334 26.717 36.7449 26.717H38.731V28.7032C38.731 29.1145 39.0643 29.448 39.4757 29.448C39.8871 29.448 40.2206 29.1147 40.2206 28.7032V26.717H42.4549C42.8663 26.717 43.1997 26.3836 43.1997 25.9722C43.1997 25.5608 42.8663 25.2274 42.4549 25.2274H40.2205V22.7448C40.2205 22.3333 39.887 22 39.4756 22C39.0642 22 38.7309 22.3333 38.7309 22.7448V25.2274H36.7448C36.3334 25.2275 36 25.5609 36 25.9722Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3964 23.2265C49.1055 22.9356 48.634 22.9356 48.343 23.2265L37.5071 34.0628C37.2164 34.3537 37.2164 34.8252 37.5071 35.116C37.6523 35.2616 37.8432 35.3344 38.0337 35.3344C38.2241 35.3344 38.415 35.2616 38.5605 35.116L49.3964 24.2801C49.6873 23.9893 49.6873 23.5173 49.3964 23.2265Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLedgerIcon);
export default __webpack_public_path__ + "static/media/Ledger_icon.fe9adc0f320b067fc2687fc7d1995abd.svg";
export { ForwardRef as ReactComponent };